import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-logo")
class Logo extends HTMLElement {
  #urls = [
    "9fb7166b-098d-429d-a1ca-1be808b358de",
    this.dataset.project,
    this.dataset.school,
  ];

  get [trait.url]() {
    return this.#urls.pop();
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @on.error("*")
  @connected
  @paint
  async [trait.template]() {
    return `
      <a>
        <img 
          src="//hzinyrqqkeqizojcotoj.supabase.co/storage/v1/object/public/logos/${this[trait.url]}"
          onerror="this.onerror=null;this.dispatchEvent(new CustomEvent('error',{bubbles:true,cancelable:true}))"
          alt="Dulino" 
          loading="eager" 
        />
      </a>
    `;
  }
}

export default Logo;
